import { Investment } from '../../core/entities/investment.entity';
import { InvestmentListResponse } from '../interfaces/investment-list.response';

export class InvestmentMapper {
   static mapResponseToInvestment(response: InvestmentListResponse): {
      data: Investment[];
      total: number;
   } {
      return {
         data: response.data.data.map((investment) => ({
            id: investment.id,
            userId: investment.user_id,
            operationDate: investment.operation_date,
            type: investment.type,
            value: investment.value,
            rate: investment.rate,
            createdAt: investment.created_at,
            updatedAt: investment.updated_at,
         })),
         total: response.data.total,
      };
   }
}
